import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-driver-license-hint',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './driver-license-hint.component.html',
  styleUrls: ['./driver-license-hint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DriverLicenseHintComponent {

}
